import {FRAGMENTS} from '../enums/enums';
import {getIpAddress} from './getIpAddress';

export const setHiddenInputs = (formElement, {anuid}) => {
  const externalIdInput = formElement.querySelector(FRAGMENTS.FORM_USER_DATA_EXTERNAL_ID);
  const clientIpAddress = formElement.querySelector(FRAGMENTS.FORM_USER_DATA_CLIENT_IP_ADDRESS);
  const clientUserAgent = formElement.querySelector(FRAGMENTS.FORM_USER_DATA_CLIENT_USER_AGENT);

  if (externalIdInput) {
    externalIdInput.value = anuid;
  } else {
    console.error('External ID input not found');
  }

  if (clientIpAddress) {
    clientIpAddress.value = getIpAddress();
  } else {
    console.error('Client IP address input not found');
  }

  if (clientUserAgent) {
    clientUserAgent.value = navigator.userAgent;
  } else {
    console.error('Client user agent input not found');
  }

};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/setHiddenInputs.js